'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { createContext as j, useState as d, useContext as y } from "react";
import { faClose as C, faCheckCircle as T, faInfoCircle as b, faTriangleExclamation as u } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as h } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import r from "../../external/classnames/index.js";
import N from "../Button/Button.js";
const p = j(void 0), A = ({ children: s }) => {
  const [a, t] = d(null), [n, o] = d(!1), l = ({
    title: i,
    message: m,
    variant: f = "info",
    buttonText: x,
    buttonLink: c
  }) => {
    t({ title: i, message: m, variant: f, buttonText: x, buttonLink: c }), o(!0), setTimeout(() => {
      o(!1);
    }, 5e3);
  };
  return /* @__PURE__ */ e.jsxs(p.Provider, { value: { showToast: l }, children: [
    s,
    a ? /* @__PURE__ */ e.jsx(
      v,
      {
        ...a,
        embedded: !1,
        isVisible: n,
        onClose: () => o(!1)
      }
    ) : null
  ] });
}, B = () => {
  const s = y(p);
  if (!s)
    throw new Error("useToast must be used within a ToastProvider");
  return s;
}, v = ({
  title: s,
  message: a,
  variant: t = "info",
  buttonText: n,
  buttonLink: o,
  embedded: l = !1,
  isVisible: i = !0,
  className: m,
  onClose: f
}) => {
  const x = {
    success: T,
    info: b,
    warning: u,
    error: u
  }, c = r({
    "bg-green text-green-dark": t === "success",
    "bg-yellow text-orange-dark": t === "warning",
    "bg-red-error text-white": t === "error",
    "bg-blue-info text-white": t === "info"
  }), g = r(
    "flex items-start gap-3 px-4 py-3 rounded-lg",
    c,
    m
  ), w = r(
    "fixed z-[10000] flex items-start gap-3 p-3 m-4 rounded-lg min-w-[6.25rem] max-w-[calc(100%-2rem)] top-0 left-0 right-0",
    "md:left-1/2 md:transform md:-translate-x-1/2 md:bottom-auto md:max-w-lg",
    "opacity-0 transition-opacity duration-1000 ease-in",
    { "opacity-100": i }
  );
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: r(g, {
        [w]: !l,
        hidden: !i
      }),
      children: [
        /* @__PURE__ */ e.jsx(h, { icon: x[t], size: "lg" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 w-full", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row justify-between gap-2", children: [
            /* @__PURE__ */ e.jsx("h5", { children: s }),
            /* @__PURE__ */ e.jsx(
              "button",
              {
                onClick: f,
                className: r({
                  hidden: l
                }),
                children: /* @__PURE__ */ e.jsx(h, { icon: C })
              }
            )
          ] }),
          a ? /* @__PURE__ */ e.jsx("p", { className: "p2", children: a }) : null,
          o && n ? /* @__PURE__ */ e.jsx(
            N,
            {
              as: "a",
              variant: "ghost",
              size: "small",
              className: r(
                c,
                "!justify-start hover:text-grey-200"
              ),
              text: n,
              href: o
            }
          ) : null
        ] })
      ]
    }
  );
};
export {
  A as ToastProvider,
  v as default,
  B as useToast
};
